import { render, staticRenderFns } from "./AccidentIncidentYearlyChart.vue?vue&type=template&id=4cda491e&scoped=true&"
import script from "./AccidentIncidentYearlyChart.vue?vue&type=script&lang=js&"
export * from "./AccidentIncidentYearlyChart.vue?vue&type=script&lang=js&"
import style0 from "./AccidentIncidentYearlyChart.vue?vue&type=style&index=0&id=4cda491e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda491e",
  null
  
)

export default component.exports